/**
 * INTERNAL ONLY
 * Do not use this outside of `data-access`.
 * Use `withPrefersReducedMotion` instead.
 */
import type {UserAttributes} from "@khan/shared-core";

/**
 * If this returns true, we should not show fancy animations, including
 * confetti, transitions, sparkles, etc. Users might want this because
 * of traumatic brain injury or various mental health reasons.
 */
export function preferReducedMotion(
    userAttributes: UserAttributes | null,
): boolean {
    // If either is defined and true, we should prefer reduced motion.
    switch (true) {
        case userAttributes?.prefersReducedMotion:
            return true;
        case typeof window !== "undefined" &&
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion)").matches:
            return true;
        default:
            return false;
    }
}
